import { FieldValues, useFormContext, useWatch } from "react-hook-form";

// This is the recommended way to get the latest form values.
// See https://react-hook-form.com/docs/usewatch

export const useFormValues = <T extends FieldValues>() => {
  const { getValues } = useFormContext<T>();

  return { ...useWatch<T>(), ...getValues() };
};
